import { useLang } from "@/context/LangContext";

export const Marquee = () => {
  const { t } = useLang();
  const text = t("marquee");
  return (
    <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#D4AF37]/15 bg-[#0B111E] py-7 md:py-10">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <p key={k} aria-hidden={k === 1} className="font-display shrink-0 whitespace-nowrap pr-8 text-5xl italic text-[#F4EEE2]/90 md:text-7xl">
            {text.split("✝").map((part, i) => (
              <span key={i}>
                {part}
                <span className="mx-6 not-italic text-[#D4AF37]">✝</span>
              </span>
            ))}
          </p>
        ))}
      </div>
    </section>
  );
};
